import { render } from "./dl-logo.vue?vue&type=template&id=c9f3dbb8"
import script from "./dl-logo.vue?vue&type=script&lang=js"
export * from "./dl-logo.vue?vue&type=script&lang=js"

import "./dl-logo.vue?vue&type=style&index=0&id=c9f3dbb8&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__